export class PrintHelper {
  static getPrintUrl(documentId: string, recipientId: string, authId: string): string {
    return `/view/${documentId}/${recipientId}/${authId}/print`;
  }
}
